import { createStyles, Theme } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      position: 'relative',
    },
    cardHeader: {
      position: 'absolute',
      right: 0,
      top: -24,
      zIndex: 1,
    },
    deleteButton: {
      height: 32,
      width: 32,
    },
    grid: {
      columnGap: spacing(4),
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      rowGap: spacing(4),
    },
    field: {
      display: 'flex',
      flexDirection: 'column',
    },
    label: {
      color: colours.neutral[900],
      fontSize: 14,
      fontWeight: 500,
      marginBottom: spacing(2),
    },
    select: {
      width: '100%',
    },
    eventTextField: {
      '& .MuiInputBase-root': {
        height: 'auto',
        minHeight: 40,
      },
    },
  });
